import { useContext } from 'react';

import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@/components/ui/resizable';
import { TraceDetails } from '@/routes/(app)/(tracing)/components/trace-details';
import { SpanDetail } from '@/routes/(app)/(tracing)/components/trace-span-details';
import { TracesTable } from '@/routes/(app)/(tracing)/components/traces-table';
import {
  TraceContext,
  TraceProvider,
} from '@/routes/(app)/(tracing)/context/trace-context';
import { useRefinedTracesByThread } from '@/routes/(app)/agents/hooks/use-refined-traces-by-thread';

interface TracingDialogProps {
  threadId: string;
  componentName: string;
}

const InnerTracingPanel = ({ threadId, componentName }: TracingDialogProps) => {
  const { traces, isLoading } = useRefinedTracesByThread(
    threadId,
    componentName
  );
  const { isOpen } = useContext(TraceContext);

  return (
    <ResizablePanelGroup direction='vertical'>
      <ResizablePanel>
        <TracesTable
          traces={traces}
          isLoading={isLoading}
        />
      </ResizablePanel>
      {isOpen && (
        <>
          <ResizableHandle withHandle />
          <ResizablePanel
            maxSize={50}
            minSize={10}>
            <TraceDetails />
          </ResizablePanel>
        </>
      )}
      {isOpen && (
        <>
          <ResizableHandle withHandle />
          <ResizablePanel
            maxSize={50}
            minSize={10}>
            <SpanDetail />
          </ResizablePanel>
        </>
      )}
    </ResizablePanelGroup>
  );
};

export const TracingPanel = (props: TracingDialogProps) => (
  <TraceProvider>
    <InnerTracingPanel {...props} />
  </TraceProvider>
);
